function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("rect", {
  width: 44,
  height: 44,
  rx: 15,
  fill: "#37D7A0"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M18.959 24.6801L30.8002 12.8389",
  stroke: "white",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M30.8 12.8389L23.803 32.2154C23.7557 32.3184 23.6799 32.4058 23.5845 32.467C23.4891 32.5282 23.3781 32.5608 23.2647 32.5608C23.1514 32.5608 23.0404 32.5282 22.945 32.467C22.8496 32.4058 22.7737 32.3184 22.7265 32.2154L18.9588 24.6801L11.4235 20.9124C11.3205 20.8652 11.2331 20.7894 11.1719 20.6939C11.1107 20.5985 11.0781 20.4875 11.0781 20.3742C11.0781 20.2608 11.1107 20.1498 11.1719 20.0544C11.2331 19.959 11.3205 19.8832 11.4235 19.8359L30.8 12.8389Z",
  stroke: "white",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var SvgSendButton = function SvgSendButton(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSendButton, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/send-button.ffc31b0d.svg";
export { ForwardRef as ReactComponent };